'use client';

import React from 'react';

interface AirMeterProps {
  airTime: number; // seconds
}

const MAX_AIR_TIME = 2.0;
const TRICK_THRESHOLD = 0.4;

export default function AirMeter({ airTime }: AirMeterProps) {
  const progress = Math.min(airTime / MAX_AIR_TIME, 1);
  const trickReady = airTime >= TRICK_THRESHOLD;
  const circumference = 2 * Math.PI * 20;
  const strokeDashoffset = circumference * (1 - progress);

  return (
    <div className="hud-glass rounded-2xl p-2 flex flex-col items-center gap-1 slide-up-in">
      <div className="relative w-12 h-12 air-meter-glow">
        <svg width="48" height="48" viewBox="0 0 48 48">
          {/* Background circle */}
          <circle
            cx="24" cy="24" r="20"
            fill="none"
            stroke="rgba(0,229,255,0.12)"
            strokeWidth="3"
          />
          {/* Progress arc */}
          <circle
            cx="24" cy="24" r="20"
            fill="none"
            stroke={trickReady ? '#ffd60a' : '#00e5ff'}
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            transform="rotate(-90 24 24)"
            style={{ transition: 'stroke-dashoffset 0.05s linear, stroke 0.2s ease' }}
          />
          {/* Center text */}
          <text
            x="24" y="28"
            textAnchor="middle"
            fill={trickReady ? '#ffd60a' : '#00e5ff'}
            fontSize="11"
            fontFamily="JetBrains Mono, monospace"
            fontWeight="700"
          >
            {airTime.toFixed(1)}s
          </text>
        </svg>
      </div>
      <p
        className="text-[9px] font-bold tracking-widest uppercase"
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: trickReady ? '#ffd60a' : '#556677',
        }}
      >
        {trickReady ? 'TRICK!' : 'AIR'}
      </p>
    </div>
  );
}